// Tiny cross-component signal: "open the catalog's inline search".
//
// The site header lives outside the FeaturedSearchProvider (which only wraps
// the /featured routes), and navigation state can't be used either — the
// page-transition wrapper only re-renders routes when the pathname changes,
// so a same-path navigate() with state never reaches the catalog page.
//
// Header: requestCatalogSearch(). If the catalog page is mounted its
// listener fires at once; otherwise the request stays pending and the page
// consumes it when it mounts.

const listeners = new Set();
let pending = false;

export function requestCatalogSearch() {
  pending = true;
  listeners.forEach((fn) => fn());
}

export function consumeCatalogSearchRequest() {
  const was = pending;
  pending = false;
  return was;
}

export function onCatalogSearchRequest(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
